import { GameVars } from "../../../../GameVars";
import { AudioManager } from "../../../../AudioManager";

export class ScoreLayer extends Phaser.GameObjects.Container {

    private suit: Phaser.GameObjects.Sprite;
    private suitExtraText: Phaser.GameObjects.Image;
    private value: Phaser.GameObjects.Text;
    private index: number;

    constructor(scene: Phaser.Scene, index: number) {

        super(scene);

        this.index = index;

        this.suit = this.scene.add.sprite(0, 0, "texture_atlas_1", "suit_0");
        this.add(this.suit);

        this.suitExtraText = new Phaser.GameObjects.Image(this.scene, 0, -70, "texture_atlas_language", "suit_4_txt");
        this.add(this.suitExtraText);

        this.value = new Phaser.GameObjects.Text(this.scene, 0, -10, "30", {fontFamily: "HelveticaNeue", fontSize: "60px", color: "#FFFFFF"});
        this.value.setStroke("#000000", 10);
        this.value.setOrigin(.5);
        this.add(this.value);

        this.visible = false;

        this.scene.anims.create({key: "suit_4", frames: this.scene.anims.generateFrameNames( "texture_atlas_1", { prefix: "suit_4_", start: 1, end: 10, zeroPad: 2, suffix: ""}), frameRate: 16});
    }

    public show(): void {

        AudioManager.playSound("points");

        this.visible = true;
        this.setScale(.5);
        this.alpha = 0;

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 250
        });

        this.scene.tweens.add({
            targets: this,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Back.Out,
            duration: 250
        });

        if (GameVars.players[this.index].result.suit === 4) {
            this.suit.anims.play("suit_4");
            this.suitExtraText.visible = true;
        } else {
            this.suit.setFrame("suit_" + GameVars.players[this.index].result.suit);
            this.suitExtraText.visible = false;
        }
        
        this.value.setText(GameVars.players[this.index].result.points.toString());
    }

    public hide(): void {

        this.visible = false;
    }
}
